import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home/progress/img_home_progress_lianxi.png'
import _imports_1 from '@/assets/num/img_1.png'
import _imports_2 from '@/assets/home/progress/img_home_progress_fangan.png'
import _imports_3 from '@/assets/num/img_2.png'
import _imports_4 from '@/assets/home/progress/img_home_progress_hetong.png'
import _imports_5 from '@/assets/num/img_3.png'
import _imports_6 from '@/assets/home/progress/img_home_progress_chuli.png'
import _imports_7 from '@/assets/num/img_4.png'
import _imports_8 from '@/assets/home/progress/img_home_progress_wancheng.png'
import _imports_9 from '@/assets/num/img_5.png'


const _withScopeId = n => (_pushScopeId("data-v-7775b939"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-pg-root hidden-md-and-down" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space-100" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-pg-title" }, "企业信用维护流程", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-pg-item-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle-40" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "h-pg-item-title-icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "h-pg-item-title-text margin-left-15" }, "联系我们")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-pg-item-text word-warp margin-top-15" }, "预先与您进行一对一专属沟通，深入了解贵企业信用方面存在的问题，精准明确您的具体诉求。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-pg-num-img",
  src: _imports_1
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promotion-i-item-bottom" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-pg-item-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle-40" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      class: "h-pg-item-title-icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "h-pg-item-title-text margin-left-15" }, "方案制定")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-pg-item-text word-warp margin-top-15" }, "围绕企业信用现存问题，由专家团队精心制定针对性极强的维护方案，规划每一个维护步骤。", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-pg-num-img",
  src: _imports_3
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promotion-i-item-bottom" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-pg-item-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle-40" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      class: "h-pg-item-title-icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "h-pg-item-title-text margin-left-15" }, "签署合同")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-pg-item-text word-warp margin-top-15" }, "签署严谨规范的合同，为您的权益筑牢坚实防线，确保您在整个维护过程中的权益得到合法保障。", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-pg-num-img",
  src: _imports_5
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promotion-i-item-bottom" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-pg-item-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle-40" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_6,
      class: "h-pg-item-title-icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "h-pg-item-title-text margin-left-15" }, "开始维护")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-pg-item-text word-warp margin-top-15" }, "专家团队与各大平台无缝对接，高质量迅速解决各类信用问题，全程实时向您反馈维护情况。", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-pg-num-img",
  src: _imports_7
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promotion-i-item-bottom" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-pg-item-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle-40" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_8,
      class: "h-pg-item-title-icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "h-pg-item-title-text margin-left-15" }, "维护成功")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-pg-item-text word-warp margin-top-15" }, "信用维护完成，深度优化企业信誉体系，重塑贵企业良好形象，在市场中更具竞争力，开启崭新的发展篇章。", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-pg-num-img",
  src: _imports_9
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promotion-i-item-bottom" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space-100" }, null, -1))

import {AppConfig} from "@/config";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeProgress',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_el_row, {
      class: "width-100 margin-top-50",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          md: 3,
          span: _unref(AppConfig).span,
          class: "h-pg-item"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, {
          md: 3,
          span: _unref(AppConfig).span,
          class: "h-pg-item"
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, {
          md: 3,
          span: _unref(AppConfig).span,
          class: "h-pg-item"
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, {
          md: 3,
          span: _unref(AppConfig).span,
          class: "h-pg-item"
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, {
          md: 3,
          span: _unref(AppConfig).span,
          class: "h-pg-item"
        }, {
          default: _withCtx(() => [
            _hoisted_20,
            _hoisted_21,
            _hoisted_22,
            _hoisted_23
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    }),
    _hoisted_24
  ]))
}
}

})